import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import './PageIndustriaAnio.css';
import './PageTop10Prensa.css';

function formatNumber(n) {
  return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
}

const PRENSA_TOTAL = 17776285;

const PRENSA_DATA = [
  { pos: 1, canal: 'LA PRENSA',       slug: 'la-prensa',       inv: 5803168, spots: 485731, inv6y: [5803168,7261407,7939483,8684997,9806763,9550833] },
  { pos: 2, canal: 'LA TRIBUNA',      slug: 'la-tribuna',      inv: 4858278, spots: 552736, inv6y: [4858278,5115924,5226697,5310268,8591609,7076565] },
  { pos: 3, canal: 'EL HERALDO',      slug: 'el-heraldo',      inv: 4366485, spots: 481798, inv6y: [4366485,4994833,5886858,6539268,7110055,6783493] },
  { pos: 4, canal: 'EL PAIS',         slug: 'el-pais',         inv: 2311982, spots: 337956, inv6y: [2311982,2606836,2638046,2589359,3962103,3147460] },
  { pos: 5, canal: 'CROMOS',          slug: 'cromos',           inv: 276251,  spots: 36118,  inv6y: [276251,274453,155949,242089,242896,280445] },
  { pos: 6, canal: 'REVISTA ESTILO',  slug: 'revista-estilo',  inv: 160121,  spots: 9710,   inv6y: [160121,214601,314516,330577,413442,291382] },
];

function Sparkline({ inv6y }) {
  const chronological = [...inv6y].reverse();
  const inv2025 = inv6y[0];
  const inv2020 = inv6y[5];
  const isUp = inv2025 >= inv2020;
  const color = isUp ? '#4ade80' : '#f87171';

  const w = 100;
  const h = 32;
  const padX = 3;
  const padY = 4;

  const max = Math.max(...chronological);
  const min = Math.min(...chronological);
  const range = max - min || 1;

  const points = chronological.map((val, i) => {
    const x = padX + (i / (chronological.length - 1)) * (w - padX * 2);
    const y = padY + (1 - (val - min) / range) * (h - padY * 2);
    return `${x},${y}`;
  });

  const polyline = points.join(' ');
  const firstX = padX;
  const lastX = padX + (w - padX * 2);
  const areaPoints = `${firstX},${h - padY} ${polyline} ${lastX},${h - padY}`;

  const pctChange = inv2020 > 0
    ? ((inv2025 - inv2020) / inv2020 * 100).toFixed(0)
    : null;

  return (
    <div className="spark-wrap">
      <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
        <defs>
          <linearGradient id={`sg-prensa-${isUp ? 'u' : 'd'}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.25" />
            <stop offset="100%" stopColor={color} stopOpacity="0.02" />
          </linearGradient>
        </defs>
        <polygon points={areaPoints} fill={`url(#sg-prensa-${isUp ? 'u' : 'd'})`} />
        <polyline points={polyline} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        {(() => {
          const lp = points[points.length - 1].split(',');
          return <circle cx={lp[0]} cy={lp[1]} r="2" fill={color} />;
        })()}
      </svg>
      <span className={`spark-pct ${isUp ? 'spark-up' : 'spark-down'}`}>
        {pctChange !== null ? (isUp ? '+' : '') + pctChange + '%' : 'NEW'}
      </span>
    </div>
  );
}

function PageTop10Prensa() {
  const navigate = useNavigate();
  const maxInv = PRENSA_DATA[0].inv;

  return (
    <PageBackground>
      <div className="top10prensa-page">
        <header className="top10prensa-header">
          <button className="btn-back" onClick={() => navigate('/top-10-radio')}>
            &#8592; Top 10 Radio
          </button>
          <div className="top10prensa-title-block">
            <h1 className="top10prensa-title">Medios de Prensa</h1>
            <p className="top10prensa-subtitle">Prensa &middot; Honduras 2025 &middot; USD &middot; ${formatNumber(PRENSA_TOTAL)}</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/highlights')}>
            Siguiente &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <div className="top10prensa-table-wrap">
          <table className="prensa-table">
            <thead>
              <tr>
                <th className="pt-pos">#</th>
                <th className="pt-name">Medio</th>
                <th className="pt-inv">Valor Mercado</th>
                <th className="pt-pct">%</th>
                <th className="pt-spots">Spots</th>
                <th className="pt-spark">Inv. 6Y</th>
              </tr>
            </thead>
            <tbody>
              {PRENSA_DATA.map((row, idx) => {
                const pct = (row.inv / PRENSA_TOTAL) * 100;
                return (
                  <tr key={row.pos} className="pt-row" style={{ animationDelay: `${idx * 0.05}s` }}>
                    <td className="pt-pos">
                      <span className={`pt-pos-badge ${row.pos <= 3 ? 'pt-pos-top3' : ''}`}>
                        {row.pos}
                      </span>
                    </td>
                    <td className="pt-name">
                      <span className="pt-canal-name pt-canal-link" onClick={() => navigate(`/top25-prensa/${row.slug}`)}>{row.canal}</span>
                      <div className="pt-bar-bg">
                        <div className="pt-bar" style={{ width: `${(row.inv / maxInv) * 100}%` }}></div>
                      </div>
                    </td>
                    <td className="pt-inv">${formatNumber(row.inv)}</td>
                    <td className="pt-pct">{pct.toFixed(2)}%</td>
                    <td className="pt-spots">{formatNumber(row.spots)}</td>
                    <td className="pt-spark"><Sparkline inv6y={row.inv6y} /></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageTop10Prensa;
